<template>
  <div class="privacy_policy">
    <article>
      <h2
        style="
          font-size: 16pt;
          line-height: 1.45;
          margin-top: 11pt;
          margin-bottom: 11pt;
          text-align: center;
          margin-left: 0px;
        "
      >
        填呗隐私政策
      </h2>
      <p style="text-align: right">本版发布日期：2021年03月30日</p>
      <p style="text-align: right">本版生效日期：2021年03月30日</p>
      <p style="text-align: right">
        <br />
      </p>
      <p>
        <span style="font-weight: bold">引言</span>
      </p>
      <p>
        北京卓闻数据科技有限公司（以下称“卓闻”或“我们”）非常重视用户个人信息的保护。您在下载、开启、浏览、注册、登录、使用“卓闻”网站（zhuowendata.com）、相应客户端内相关产品和/或服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，我们将如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。
      </p>
      <p>
        <br />
      </p>
      <p>
          <strong>收集权限信息说明：</strong><br/>(1) 为识别您的设备ID并预防恶意程序及反作弊、提高服务安全性、保障运营质量及效率，我们会收集您的设备信息(包括读取设备IP、读取WIFI的SSID、MAC地址、IMEI、MEID、Android IDIMSI、GUID、IDFA、OAID、OpenUDID、SIM卡IMSI、ICCID)，为用户的唯一标识，用于区分唯一用户，防止问卷信息作弊。<br/>(2)为对填呗APP错误异常进行监控，以及对平台进行优化升级，我们将收集应用软件运行异常信息。<br/>(3)为对填呗APP实现运行故障报错及分析和解决您在使月过程中所遇到的间题，我们将收朱您的设备信息 (GUID、MAC地址)、浏览和操作记录。<br/>(4)为了在填写问卷过程中防止欺诈及保护您资金安全，我们将收集您的设备位置信息。<br/> (5)读取剪切板内容，可以将剪切板的内容作为申请问卷调研，快速发布申请调研。
      </p>
      <br>
      <p>填呗APP-涉及收集用户信息的第三方SDK列表</p>
      <div class="box">
        <table border="1px" align="center">
          <colgroup>
              <col width="247" style="width:15%"/>
              <col width="250" style="width:15%"/>
              <col width="204" style="width:10%"/>
              <col width="213" style="width:10%"/>
              <col width="372" style="width:20%"/>
              <col width="916" style="width:30%"/>
          </colgroup>
          <tbody>
              <tr style="height:19px" class="firstRow">
                  <td width="247" style="">
                      第三方公司名称
                  </td>
                  <td width="251" style="">
                      产品/服务
                  </td>
                  <td width="204" style="">
                      涉及个人信息
                  </td>
                  <td width="213" style="">
                      使用场景
                  </td>
                  <td width="372" style="">
                      使用目的
                  </td>
                  <td width="916" style="">
                      第三方链接
                  </td>
              </tr>
              <tr style="height:92px">
                  <td rowspan="2" width="247" style="">
                      友盟同欣（北京）科技有限公司
                  </td>
                  <td rowspan="2" width="251" style="">
                      友盟统计
                  </td>
                  <td rowspan="2" width="204" style="">
                    设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID/BSSID）、位置信息、网络信息
                  </td>
                  <td rowspan="2" width="213" style="">
                      进行APP数据统计分析
                  </td>
                  <td rowspan="2" width="372" style="border-bottom: 1px solid rgb(0, 0, 0);">
                      设备信息：用于生成脱敏的终端用户设备标识，以提供统计分析服务。<br/>网络信息：用于优化网络连接请求，以提供持续稳定的统计分析服务；基于位置信息实现区域统计功能，生成区域数据报表。<br/>位置信息：为开发者提供反作弊功能，剔除作弊设备；同时矫正用户的地域分布数据，提供区域数据统计报表。
                  </td>
                  <td rowspan="2" width="916" style="">
                      官网链接：https://www.umeng.com/analytics<br/>隐私政策链接：https://www.umeng.com/page/policy
                  </td>
              </tr>
              <tr style="height:55px"></tr>
              <tr style="height:54px">
                  <td rowspan="4" width="247" style="">
                      深圳市和讯华谷信息技术有限公司
                  </td>
                  <td rowspan="4" width="251" style="">
                      极光推送
                  </td>
                  <td width="204" style="">
                      设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)
                  </td>
                  <td rowspan="4" width="213" style="">
                      向用户推送通知消息时使用
                  </td>
                  <td width="372" style="">
                      用于识别用户的设备类型、设备型号、系统版本等，确保消息准确下发
                  </td>
                  <td rowspan="4" width="916" style="">
                      官网链接：https://www.jiguang.cn/push<br/>隐私政策链接：https://www.jiguang.cn/license/privacy
                  </td>
              </tr>
              <tr style="height:90px">
                  <td width="204" style="">
                      设备标识符（IMEI、IDFA、Android ID、GAID、 MAC、OAID、VAID、AAID、IMSI、MEID、UAID、硬件序列号信息、ICCID、SIM信息）
                  </td>
                  <td width="372" style="">
                      用于识别唯一用户，保证推送的精准送达及推送信息的准确统计
                  </td>
              </tr>
              <tr style="height:72px">
                  <td width="204" style="">
                      网络信息(IP 地址、WiFi 信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）
                  </td>
                  <td width="372" style="">
                      用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能
                  </td>
              </tr>
              <tr style="height:72px">
                  <td width="204" style="">
                      应用列表信息(应用崩溃信息、通知开关状态、APP 应用列表及活跃状态、APP 应用页面信息、APP 功能事件相关信息)
                  </td>
                  <td width="372" style="">
                      当一个设备有多个 APP 的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的
                  </td>
              </tr>
              <tr style="height:54px">
                  <td width="247" style="">
                      财付通支付科技有限公司
                  </td>
                  <td width="251" style="">
                      微信支付
                  </td>
                  <td width="204" style="">
                      设备信息（IMEI、IMSI、MAC地址、AndroidID）、网络信息、微信账号信息
                  </td>
                  <td width="213" style="">
                      在用户每次选择第三方支付方式时使用
                  </td>
                  <td width="372" style="">
                      根据用户选择，为用户提供第三方支付功能
                  </td>
                  <td width="916" style="">
                      官网链接：https://pay.weixin.qq.com/static/applyment_guide/applyment_index.shtml<br/>隐私政策链接：https://www.tenpay.com/v3/helpcenter/low/privacy.shtml
                  </td>
              </tr>
              <tr style="height:54px">
                  <td width="247" style="">
                      深圳市腾讯计算机系统有限公司
                  </td>
                  <td width="251" style="">
                      微信
                  </td>
                  <td width="204" style="">
                      设备信息（IMEI、IMSI、MAC地址、AndroidID）、网络信息、微信账号信息
                  </td>
                  <td width="213" style="">
                      在用户进行登陆、信息分享时使用
                  </td>
                  <td width="372" style="">
                      根据用户选择，为用户提供内容分享至第三方平台功能
                  </td>
                  <td width="916" style="">
                      官网链接：https://open.weixin.qq.com/<br/>隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy
                  </td>
              </tr>
          </tbody>
      </table>
        <!-- <table border="1px">
            <tr>
                <td class="tit" style="width:13%;">第三方公司名称</td>
                <td class="tit" style="width:13%;">产品/服务</td>
                <td class="tit" style="width:20%;">涉及个人信息</td>
                <td class="tit" style="width:11%;">使用场景</td>
                <td class="tit" style="width:14%;">使用目的</td>
                <td class="tit" style="width:29%;">第三方链接</td>
            </tr>
            <tr>
                <td>友盟同欣（北京）科技有限公司</td>
                <td>友盟统计</td>
                <td>设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息</td>
                <td>进行APP数据统计分析</td>
                <td>基于设备信息用于生成脱敏的终端用户设备标识，以提供统计分析服务。基于网络信息用于优化网络连接请求，以提供持续稳定的统计分析服务；基于位置信息实现区域统计功能，生成区域数据报表。</td>
                <td style="29%">官网链接：https://www.umeng.com/analytics 隐私政策链接：https://www.umeng.com/page/policy</td>
            </tr>
            <tr>
                <td>深圳市和讯华谷信息技术有限公司</td>
                <td>极光推送</td>
                <td>设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)</td>
                <td>向用户每次推送通知消息时使用</td>
                <td>根据用户机型，为用户提供通知信息推送功能</td>
                <td style="29%">官网链接：https://www.jiguang.cn/push隐私政策链接：https://www.jiguang.cn/license/privacy</td>
            </tr>
            <tr>
                <td>财付通支付科技有限公司</td>
                <td>微信支付</td>
                <td>设备信息（IMEI、IMSI、MAC地址、AndroidID）、网络信息、微信账号信息</td>
                <td>在用户每次选择第三方支付方式时使用</td>
                <td>根据用户选择，为用户提供第三方支付功能</td>
                <td style="29%">官网链接：https://pay.weixin.qq.com/static/applyment_guide/applyment_index.shtml隐私政策链接：https://www.tenpay.com/v3/helpcenter/low/privacy.shtml</td>
            </tr>
            <tr>
                <td>深圳市腾讯计算机系统有限公司</td>
                <td>微信</td>
                <td>设备信息（IMEI、IMSI、MAC地址、AndroidID）、网络信息、微信账号信息</td>
                <td>在用户进行信息分享时使用</td>
                <td>根据用户选择，为用户提供内容分享至第三方平台功能</td>
                <td style="29%">官网链接：https://open.weixin.qq.com/隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</td>
            </tr>
        </table> -->
    </div>
      <p>
        <span style="font-weight: bold"
          >在使用卓闻各项产品或服务之前，请您务必仔细阅读并透彻理解本政策，在确认充分理解后作出适当选择。勾选“我接受填呗隐私政策”按钮（或其他表示您接受该政策的按钮）表示您同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。一旦您使用或在我们更新本《隐私政策》后继续使用我们的产品或服务，即意味着您同意本《隐私政策》及更新后内容并同意我们按照本《隐私政策》处理您的相关个人信息。如果您不同意本《隐私政策》，请不要使用或立即停止使用我们的产品和/或服务。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，以便您的理解。本《隐私政策》中与您的权益存在或可能存在重大关系的条款，我们已采用加粗字体提醒您特别注意。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >特别说明的是，本《隐私政策》适用于卓闻旗下现存有效以及将来可能发布运行的平台、产品、服务，如果我们关联公司的产品和/或服务使用了众言提供的产品和/或服务但未设独立的隐私政策的，则本《隐私政策》同样适用该部分产品和/或服务。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        本《隐私政策》所指的关联方，是指对卓闻而言，有能力直接或间接控制、共同控制或对其施加重大影响的主体，以及与卓闻同受一方控制、共同控制或重大影响的主体。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">本《隐私政策》包含以下内容：</span>
      </p>
      <p>1.我们如何收集您的个人信息</p>
      <p>
        <br />
      </p>
      <p>2.我们如何存储您的信息</p>
      <p>
        <br />
      </p>
      <p>3.我们如何使用Cookie和同类技术</p>
      <p>
        <br />
      </p>
      <p>4.我们如何使用信息</p>
      <p>
        <br />
      </p>
      <p>5.您如何访问和管理自己的个人信息</p>
      <p>
        <br />
      </p>
      <p>6.我们如何与第三方共享、转让、披露您的个人信息</p>
      <p>
        <br />
      </p>
      <p>7.信息安全</p>
      <p>
        <br />
      </p>
      <p>8.您分享的信息</p>
      <p>
        <br />
      </p>
      <p>9.第三方服务</p>
      <p>
        <br />
      </p>
      <p>10.我们可能向您发送的邮件和信息</p>
      <p>
        <br />
      </p>
      <p>11.未成年人使用我们的产品和/或服务</p>
      <p>
        <br />
      </p>
      <p>12.隐私政策的适用范围</p>
      <p>
        <br />
      </p>
      <p>13.本政策的变更</p>
      <p>
        <br />
      </p>
      <p>14.联系、投诉及举报</p>
      <p>
        <br />
      </p>
      <p>15.产品和/或服务的运营者信息</p>
      <p>
        <br />
      </p>
      <p>16.适用法律与争议解决</p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">1.我们如何收集您的个人信息</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >为了向所有用户提供更好的产品和/或服务，我们可能会收集、储存您的信息。</span
        ><span
          style="
            font-weight: bold;
            font-family: undefined, undefined, undefined, undefined;
          "
          >为了保障软件与服务的正常运行，我们会收集您的硬件型号、操作系统版本号、国际移动设备识别码(IMEI)、网络设备硬件地址(MAC)、IP地址、软件版本号、读写外置存储信息、网络接入方式及类型、操作日志信息(如服务故障信息)，这类信息是为提供服务必须收集的基础信息。</span
        ><span style="font-weight: bold"
          >我们收集信息的主要来源有：您向卓闻提供的信息、卓闻在您使用卓闻旗下产品和/或服务过程中获取的信息、您通过我们的产品和/或服务向其他方提供的共享信息。</span
        >我们将合法合理且最小化收集您的个人信息。卓闻将通过以下目的，收集和使用您的个人信息：
      </p>
      <p>
        <br />
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">第三方SDK列表</span>
      </p>
      <p>
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">一、社交类服务</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">SDK名称：微信开放平台SDK</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">使用目的：用于通过微信与用户在线沟通交流</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">收集个人信息类型：设备信息</span><span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">(IMEI/MAC/Android&nbsp;ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等)</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">隐私权限政策链接：</span>https://open.weixin.qq.com/cgi-bin/frame?t=home/app_tmpl&amp;lang=zh_CN
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">&nbsp;</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">二、统计分析类服务</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">SDK名称：Umeng（友盟）SDK</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">使用目的：用于应用的统计分析</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">收集个人信息类型：设备信息</span><span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">（IMEI/AndroidID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/MAC地址/BSSID/SN/SSID/硬件序列号/ICCID）、陀螺仪传感器、定位信息、网络类型、设备型号、设备品牌、运营商信息</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">隐私权限政策链接：</span>https://developer.umeng.com/docs/119267/detail/118585；https://www.umeng.com/push
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">&nbsp;</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">三、推送类服务</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">SDK名称：极光推送SDK</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">使用目的：用于消息推送</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">收集个人信息类型：设备信息</span><span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">(IMEI/MAC/Android&nbsp;ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等)</span>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">隐私权限政策链接：</span><a href target="_blank"><span style="font-family:微软雅黑, 微软雅黑, undefined, 微软雅黑">https://open.oppomobile.com/wiki/doc#id=10288</span></a>
      </p>
      <p style="margin-top: 0px;margin-bottom: 0px">
          <br/>
      </p>
      <p>
        <span style="font-weight: bold">1.1&nbsp;注册和登录</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        如果您使用卓闻做商业调研问卷、趣味活动、积分兑换、签到、抽奖、邀请好友、意见反馈功能，您需要注册/登录（登录即代表您注册成为卓闻的用户），我们将根据您注册/登录的方式，收集以下个人信息：
      </p>
      <p>
        <br />
      </p>
      <p>
        1.1.1&nbsp;<span style="font-weight: bold">手机号码</span
        >：是您选择使用手机号码注册/登录时，主动向我们提供的个人信息。同时，我们将通过发送短信验证码的方式来验证您的账户是否有效。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >1.2&nbsp;为您展示信息或服务</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        为向您提供信息或服务，展示您所在地域及其他相关的调查问卷，我们可能收集和使用您的以下个人信息并进行分析：
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >a)&nbsp;您的浏览、收藏、搜索记录。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >b)&nbsp;您主动提供的点赞、分享、关注、反馈的行为信息。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >c)&nbsp;获得您同意后的地理位置信息。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >d)&nbsp;您在我们的产品/服务内提交的身份信息（即头像、昵称、性别、生日、学历、居住城市、职业类型、年收入、婚姻状态、代步工具）</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >e)&nbsp;浏览器自动收集的一些信息，包括浏览器类型、IP地址、设备型号、系统版本</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >f)&nbsp;获取您的设备中安装的其他应用程序列表以及下载后是否唤醒（此权限仅基于Android系统开发）</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        您可以通过不填写问卷、不填写个人资料方式来拒绝提供上述信息，拒绝我们调用或关闭地理位置权限、设备权限以不提供地理位置和设备信息。您不提供上述行为信息的，我们向您展示信息或服务会降低精准度和相关度，但不影响您正常使用其他功能。
      </p>
      <p>
        您拒绝或关闭地理位置权限的，我们将不会基于地理位置向您推送信息，但不会影响您正常使用其他不需该权限的功能。
      </p>
      <p>
        <br />
      </p>
      <p>
        您拒绝或关闭设备信息的，我们向您展示信息会降低精准度和相关度，但不影响您正常使用其他不需要该权限的功能。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">1.3&nbsp;向我们反馈问题</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        如果您想通过上传图片的方式向我们反馈问题、提交建议，需要开启相册或相机权限以上传或拍摄图片。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">1.4&nbsp;提现信息</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        如果您想把所获现金奖励提现到微信账号内，需要提供您的微信账号信息，以便我们将对应的现金发放到您的微信钱包中。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">1.5&nbsp;邀请好友加入</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        当您将分享链接转发到微信朋友圈/微信好友时，我们会获取对应第三方网站的信息以确保该内容能分享成功。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">1.6&nbsp;消息推送、站内信和提醒</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        若您需要接收我们的消息推送、站内信和提醒（答卷收集提醒、发布问卷提醒），您需要开启相应通知授权，我们可以在第一时间将相关信息推送给您，若未授权通知，不影响您使用我们提供的其他服务。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">1.7&nbsp;支付费用</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        您在购买卓闻提供的产品和/或服务时，如您选择以微信方式支付费用，在选择特定支付方式时您需要提供您的微信信息我们，以便您购买想要的产品和/或服务。在您的支付过程中，卓闻不会向任何第三方提供有关您个人之隐私资料。<span
          style="font-weight: bold"
          >您支付时直接跳转到第三方支付页面的，该等第三方将会直接收集您的支付信息，该等信息的收集、使用、储存和分享将遵守第三方的隐私条款，与卓闻无关，请您注意事先仔细查看。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        1.8&nbsp;<span style="font-weight: bold"
          >为提高您使用卓闻提供服务的安全性，保护您或其他公众的人身财产安全免遭侵害，更好地预防因钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入、违法违规内容而产生的安全风险，更准确地识别违反法律法规或我们制定的相关协议规则的情况，我们可能使用或整合您的账号信息、交易信息、设备信息、位置信息、日志信息以及我们关联方、第三方合作伙伴获得您授权或依据法律共享的信息，来综合判断您的账号及交易风险、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        1.8.1日志信息，指您使用我们的产品和/或服务时，我们的系统可能通过cookies、web&nbsp;beacon或其他方式自动采集的技术信息，包括：
      </p>
      <p>
        <br />
      </p>
      <p>
        a)&nbsp;<span
          style="font-family: undefined, undefined, undefined, undefined"
          >设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们产品和/或服务的其他程序所提供的配置信息、移动设备所用的版本、设备所在位置相关信息（</span
        ><span
          style="
            font-weight: bold;
            font-family: undefined, undefined, undefined, undefined;
          "
          >例如设备品牌及型号、操作系统版本号、国际移动设备识别码(IMEI)、网络设备硬件地址(MAC)、IP&nbsp;地址、GPS位置、网络使用习惯</span
        ><span style="font-family: undefined, undefined, undefined, undefined"
          >）等；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;在使用我们产品和/或服务时搜索或浏览的信息，例如您使用的网页搜索词语、浏览器类型、访问的社交媒体页面url地址、访问的日期和时间、系统的错误日志及您访问的网页记录，以及您在使用我们产品和/或服务时浏览或要求提供的其他信息和内容详情等；
      </p>
      <p>
        <br />
      </p>
      <p>c)&nbsp;有关您曾使用的移动应用（APP）和其他软件的信息；</p>
      <p>
        <br />
      </p>
      <p>
        d)&nbsp;您通过我们的产品和/或服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长等；
      </p>
      <p>
        <br />
      </p>
      <p>
        e)&nbsp;通过我们的产品和/或服务分享的内容所包含的信息（元数据），例如拍摄或上传的照片、录音或录像的日期、时间或地点等。
      </p>
      <p>
        <br />
      </p>
      <p>
        f)&nbsp;我们可能会获得您在使用第三方合作伙伴时所产生或分享的信息。例如，您使用微信登录第三方合作伙伴服务时，我们会获得您登录第三方合作伙伴服务的名称、登录时间，方便您进行授权管理。请您仔细阅读第三方合作伙伴的服务协议或隐私协议。
      </p>
      <p>
        <br />
      </p>
      <p>
        1.8.2&nbsp;位置信息，包括您或其他用户在使用卓闻产品和/或服务时向我们提供的包含您所处地理位置的信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        1.8.3&nbsp;为了给您提供完善的产品和/或专属服务，您在使用我们的产品和/或服务时系统所收集的信息，例如为向您提供更契合您个人的调研，我们可能会收集关于您使用的服务以及使用方式的个人信息并将这些个人信息进行关联。
      </p>
      <p>
        <br />
      </p>
      <p>
        您可以通过手机设备中“【设置】”-“【应用】”【应用管理/启动管理/权限管理/】中逐项查看您上述权限的开启状态，并可以决定将这些权限随时开启或关闭。请您注意，您开启这些权限代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权相对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
      </p>
      <p>
        <br />
      </p>
      <p>1.9&nbsp;征得授权同意的例外</p>
      <p>
        <br />
      </p>
      <p>
        根据相关法律法规规定，出现以下情形的，我们收集和使用您的个人信息无需征得您的授权同意：
      </p>
      <p>
        <br />
      </p>
      <p>a)&nbsp;与国家安全、国防安全有关的；</p>
      <p>
        <br />
      </p>
      <p>b)&nbsp;与公共安全、公共卫生、重大公共利益有关的；</p>
      <p>
        <br />
      </p>
      <p>c)&nbsp;与犯罪侦查、起诉、审判和决定书、裁判执行等有关的；</p>
      <p>
        <br />
      </p>
      <p>
        d)&nbsp;出于维护个人信息主体或其他个人的生命、财产重大合法权益但又很难得到您本人同意的；
      </p>
      <p>
        <br />
      </p>
      <p>e)&nbsp;所收集的个人信息是您自行向社会公众公开的；</p>
      <p>
        <br />
      </p>
      <p>
        f)&nbsp;从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开、新媒体平台等渠道；
      </p>
      <p>
        <br />
      </p>
      <p>g)&nbsp;根据您的要求签订合同所必需的的；</p>
      <p>
        <br />
      </p>
      <p>
        h)&nbsp;用于维护所提供的产品或服务的安全稳定所必需的，例如发现、处置产品或服务的故障；
      </p>
      <p>
        <br />
      </p>
      <p>i)&nbsp;为合法的新闻报道所必需的；</p>
      <p>
        <br />
      </p>
      <p>
        j)&nbsp;学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
      </p>
      <p>
        <br />
      </p>
      <p>k)&nbsp;法律法规规定的其他情形。</p>
      <p>
        <br />
      </p>
      <p>
        请您理解并同意，如您的信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；只有当您的信息可以单独或结合其他信息识别到您的个人身份时，则在结合使用期间，将作为您的个人信息按照本政策处理与保护。
      </p>
      <p>
        <br />
      </p>
      <p>2.&nbsp;我们如何存储您的信息</p>
      <p>
        <br />
      </p>
      <p>
        2.1&nbsp;我们在中华人民共和国境内运营中收集和产生的个人信息，原则上存储在中国境内，以下情形除外：
      </p>
      <p>
        <br />
      </p>
      <p>a)&nbsp;法律法规有明确规定；</p>
      <p>
        <br />
      </p>
      <p>b)&nbsp;获得您的明确授权。</p>
      <p>
        <br />
      </p>
      <p>2.2&nbsp;我们综合考虑以下要素来确定保存您的个人信息期限：</p>
      <p>
        <br />
      </p>
      <p>
        a)&nbsp;法律规定的最低储存期限，如《网络安全法》《电子商务法》等规定的最短保存时间；
      </p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;为提供我们的产品/服务之目的所必需的期限，如在您使用手机号码注册/登录后使用相应的功能时，我们会在您提供且使用该功能期间，持续保存您的手机号码，以向您正常提供该功能。
      </p>
      <p>
        <br />
      </p>
      <p>
        c)&nbsp;履行其他法定义务而保存的期限，如根据《信息网络传播保护条例》第十三条规定，我们需向著作权行政管理部门提供涉嫌侵权服务对象的姓名（名称）、联系方式等信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        d)&nbsp;监测、记录网络运行状态、网络安全事件的相关网络日志保存时间不少于六个月。
      </p>
      <p>
        <br />
      </p>
      <p>
        2.3&nbsp;超出上述信息保留期限的个人用户信息，我们会依据相关法律法规以及制定的规定，使用格式化等方式对用户个人信息删除或进行匿名化处理。
      </p>
      <p>
        <br />
      </p>
      <p>
        3.&nbsp;<span style="font-weight: bold"
          >我们如何使用Cookie和同类技术</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        3.1&nbsp;我们或我们的第三方合作伙伴，可能通过cookies和web&nbsp;beacon收集和使用您的信息，并将该等信息储存为日志信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        3.2&nbsp;我们使用自己的cookies和类似技术，目的是为您提供更好的用户体验和产品和/或服务，并用于以下用途：
      </p>
      <p>
        <br />
      </p>
      <p>
        3.2.1&nbsp;<span style="font-weight: bold">记住您的身份</span
        >。例如：cookies有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的偏好信息；
      </p>
      <p>
        <br />
      </p>
      <p>
        3.2.2&nbsp;<span style="font-weight: bold"
          >分析您使用我们产品和/或服务的情况</span
        >。例如，我们可利用cookies来了解您使用我们的产品和/或服务进行什么活动，或哪些网页或产品和/或服务最受您的欢迎；
      </p>
      <p>
        <br />
      </p>
      <p>
        3.2.3&nbsp;Cookies和web&nbsp;beacon有助于我们根据您的信息，向您提供与我们的产品和/或服务相关信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        3.3&nbsp;我们为上述目的使用cookies的同时，<span
          style="font-weight: bold"
          >可能将通过cookies收集的非个人身份信息，经统计加工后提供给广告商和其他合作伙伴</span
        >，用于分析用户如何使用我们的产品和/或服务。
      </p>
      <p>
        <br />
      </p>
      <p>
        3.4&nbsp;我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web&nbsp;beacon。这些cookies和web&nbsp;beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等产品和/或服务。<span
          style="font-weight: bold"
          >这些第三方cookies和web&nbsp;beacon收集和使用该等信息，不受本《隐私政策》约束，而是受到其自身的隐私政策约束，我们不对第三方的cookies或web&nbsp;beacon承担责任</span
        >。
      </p>
      <p>
        <br />
      </p>
      <p>
        3.5&nbsp;您可以通过浏览器设置拒绝或管理cookies。但请注意，如果停用cookies或web&nbsp;beacon，我们有可能无法为您提供最佳的服务体验，某些产品和/或服务也可能无法正常使用。
      </p>
      <p>
        <br />
      </p>
      <p>
        3.6&nbsp;为了确认您的使用形态与网站的使用状况，<span
          style="font-weight: bold"
          >我们的网站会记录您设备的IP地址与浏览器的类型，用户的浏览行为和操作行为等，以协助我们改善卓闻的设计与编排格式</span
        >。
      </p>
      <p>
        <br />
      </p>
      <p>4.&nbsp;<span style="font-weight: bold">我们如何使用信息</span></p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1&nbsp;我们可能将在向您提供产品和/或服务的过程之中所收集的信息用作下列用途：</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.1&nbsp;向您提供产品和/或服务，我们所收集和使用的个人信息是为您提供卓闻服务的必要条件，如缺少相关个人信息，我们将无法为您提供卓闻服务的核心内容；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.2&nbsp;在我们提供产品和/或服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.3&nbsp;帮助我们设计新产品和/或服务，改善我们现有产品和/或服务；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.4&nbsp;使我们更加了解您如何接入和使用我们的产品和/或服务，从而针对性地回应您的需求，例如语言设定、位置设定等帮助服务和指示，或对您和其他用户作出其他方面的回应；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.5&nbsp;向您提供卓闻相关的产品和/或服务；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.6&nbsp;评估我们产品或服务中的和其他活动的效果，并加以改善；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.7&nbsp;软件认证或管理软件升级；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >4.1.8&nbsp;让您参与有关我们产品和/或服务的调查，或者促销及推广等活动；</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold">4.1.9&nbsp;经您同意的其他用途。</span>
      </p>
      <p>
        <br />
      </p>
      <p>
        4.2&nbsp;为了让您有更好的体验、改善我们的产品和/或服务或您同意的其他用途，在符合相关法律法规的前提下，<span
          style="font-weight: bold"
          >我们可能将通过某一项产品和/或服务所收集的信息，以汇集信息，用于我们的其他产品和/或服务。例如，在您使用我们的一项产品或服务时所收集的信息，可能在另一产品或服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关产品和/或服务中提供了相应选项，您也可以授权我们将该产品和/或服务所收集和储存的信息用于我们的其他产品和/或服务。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        4.3&nbsp;为了给您提供完善的产品和/或服务，提升您的用户体验，在收集您的个人信息后，我们可能会对用户数据库进行分析并予以商业化的利用。我们将遵循法律法规和合法必要的原则，对相关信息采取必要的安保措施，比如通过技术手段对数据进行去标识化处理等。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >您了解并同意，在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理后的个人信息将无法识别您的身份，在此情况下我们有权使用去标识化的个人信息，对用户数据库进行分析并予以商业化的利用。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        5.&nbsp;<span style="font-weight: bold"
          >您如何访问和管理自己的个人信息</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>5.1&nbsp;<span style="font-weight: bold">查询您的个人信息</span></p>
      <p>
        <br />
      </p>
      <p>
        您可以随时登录自己的账户查看您的个人信息。点击“我的”查询您的头像、昵称；点击“我的”-“个人信息”查看您的性别、生日、学历、居住城市、职业类型、年收入、婚姻状态、代步工具。&nbsp;
      </p>
      <p>
        如果您无法通过上述路径访问和管理该等个人信息，您可以随时通过本《隐私政策》所示联系方式与我们取得联系，我们将在收到您的请求之日起15日内回复您的访问请求。
      </p>
      <p>
        <br />
      </p>
      <p>5.2&nbsp;<span style="font-weight: bold">更正个人信息</span></p>
      <p>
        <br />
      </p>
      <p>
        账户信息—请您理解，为了避免因频繁修改个人资料以达到匹配问卷要求的现象，我们对个人资料的修改进行了更正的权限。其中，对于“头像、昵称、性别、生日、学历、居住城市、职业类型、年收入、婚姻状态、代步工具”您一个自然年有3次修改机会。但是在实名认证后，对于“性别、生日”您无修改权限。
      </p>
      <p>
        <br />
      </p>
      <p>
        若确实因为特殊情况，您确需要修改个人信息，您可以通过本《隐私协议》所示联系方式与我们管理员取得联系，由管理员帮助您进行修改。
      </p>
      <p>
        <br />
      </p>
      <p>5.3&nbsp;<span style="font-weight: bold"> 注销账号(删除个人信息)</span></p>
      <p>
        <br />
      </p>
      <p style="margin-top: 0px; margin-bottom: 0px;">
          <span style="font-family:undefined, undefined, undefined, undefined">您有权注销您的填呗账号，您可以通过访问</span>&nbsp;App“我的”页面下方“<span style="font-family:undefined, undefined, undefined, undefined">系统</span>设置”-“注销账<span style="font-family:undefined, undefined, undefined, undefined">号</span>”中进行在线操作。<span style="font-weight:bold">您注销成功后，除法律法规及相应的国家标准另有规定外，我们将删除您的个人信息或作匿名化处理。</span><span style="font-family:undefined, undefined, undefined, undefined">如果您无法通过上述方式访问、更正或删除您的个人信息以及注销账号，或者如果您认为填呗存在违反法律的规定收集、使用您个人信息的情形，您可以通过我们的客服或通过本隐私政策提供的其他方式与我们取得联系。为了保障安全，我们可能需要您提供相应方式证明您的身份和请求的正当性，我们将在收到您反馈并验证您的身份后的</span>&nbsp;15&nbsp;天内答复您的请求。对于您合理的请求，我们原则上不<span style="font-family:undefined, undefined, undefined, undefined">收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span>
      </p>
      <br>
      <p>
        5.3.1&nbsp;您可以通过本条中列明的方式删除您的部分个人信息。在以下情形中，您可以向我们提出删除个人信息的请求：
      </p>
      <p>a)&nbsp;我们处理个人信息的行为违反法律法规；</p>
      <p>
        <br />
      </p>
      <p>b)&nbsp;我们收集、使用您的个人信息，却未征得您的明确同意；</p>
      <p>
        <br />
      </p>
      <p>c)&nbsp;我们处理个人信息的行为严重违反了与您的约定；</p>
      <p>
        <br />
      </p>
      <p>d)&nbsp;您不再使用我们的产品或服务，或您主动申请注销账号；</p>
      <p>
        <br />
      </p>
      <p>
        e)&nbsp;若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。当您从我们的服务中删除信息后，我们将不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
      </p>
      <p>
        <br />
      </p>
      <p>5.4&nbsp;<span style="font-weight: bold">撤回您的授权</span></p>
      <p>
        <br />
      </p>
      <p>5.4.1&nbsp;您可以通过删除个人信息撤回您的授权。</p>
      <p>
        <br />
      </p>
      <p>您可以通过“设置”-“应用”选择关闭权限，以此来撤回您的授权。</p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务和功能，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>5.5&nbsp;<span style="font-weight: bold">获取个人信息副本</span></p>
      <p>
        <br />
      </p>
      <p>
        如您需要获取您向我们提供的个人信息以及我们通过本《隐私政策》约定收集您的个人信息，请您通过本《隐私政策》列明的联系方式与我们取得联系并提出此项需求，我们将在15日内处理您的请求。
      </p>
      <p>
        <br />
      </p>
      <p>5.6&nbsp;<span style="font-weight: bold">管理您的推送</span></p>
      <p>
        <br />
      </p>
      <p>
        5.6.1&nbsp;我们所提供的“消息推送”是向您推送最新问卷，由您自主选择开启或关闭的功能，用于接收我们推送的重要通知。您可以通过以下方式来管理和选择您的“推送”：点击“手机-设置-推送服务。”-消息推送进行关闭或开启。
      </p>
      <p>
        <br />
      </p>
      <p>
        5.6.2&nbsp;您的上述操作可以实现自主控制信息或服务所依赖的个人信息，使您具有调控信息展示相关程度的能力。
      </p>
      <p>
        <br />
      </p>
      <p>5.7&nbsp;响应您的上述请求</p>
      <p>
        <br />
      </p>
      <p>
        5.7.1&nbsp;为保障安全，您需要向我们主动提出请求，或以其他方式证明您的身份。我们会先要求您验证自己的身份，然后再处理您的请求。
      </p>
      <p>
        <br />
      </p>
      <p>
        5.7.2.&nbsp;我们将在收到您的请求后15日内做出答复。如您不满意，还可以通过本《隐私政策》列明的联系方式发起投诉。
      </p>
      <p>
        <br />
      </p>
      <p>
        5.7.3&nbsp;对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
      </p>
      <p>
        <br />
      </p>
      <p>5.7.4&nbsp;在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
      <p>
        <br />
      </p>
      <p>a)&nbsp;与国家安全、国防安全有关的；</p>
      <p>
        <br />
      </p>
      <p>b)&nbsp;与公共安全、公共卫生、重大公共利益有关的；</p>
      <p>
        <br />
      </p>
      <p>
        c)&nbsp;与犯罪侦查、起诉、审判和执行判决、裁定或行政机关的决定书等有关的；
      </p>
      <p>
        <br />
      </p>
      <p>d)&nbsp;有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
      <p>
        <br />
      </p>
      <p>
        e)&nbsp;响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
      </p>
      <p>
        <br />
      </p>
      <p>f)&nbsp;涉及商业秘密的。</p>
      <p>
        <br />
      </p>
      <p>5.8&nbsp;停止运营</p>
      <p>
        <br />
      </p>
      <p>
        如我们停止运营，将及时停止继续收集您的个人信息的活动，会将停止运营的通知以公告的形式通知您，并对所持有您的个人信息进行删除或匿名化处理。
      </p>
      <p>
        <br />
      </p>
      <p>
        6.&nbsp;<span style="font-weight: bold"
          >我们如何与第三方共享、转让、披露您的个人信息</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        我们的应用中会嵌入授权合作伙伴的SDK或其他类型的应用程序。通过应用程序接口(API)、软件工具开发包(SDK)与第三方进行必要的数据共享，不同版本的第三方SDK会有所不同，一般包括第三方账号登录类、分享类、第三方支付类、地图导航类、厂商推送类、统计类等，我们会对第三方进行严格的安全检测并约定数据保护措施。<span
          style="color: rgb(46, 83, 235)"
          @click="showSDK"
          >点击查看我们嵌入的第三方SDK详情</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>6.1&nbsp;共享</p>
      <p>
        <br />
      </p>
      <p>
        6.1.1&nbsp;我们会以高度的勤勉义务对待您的信息，<span
          style="font-weight: bold"
          >除以下情形外，未经您同意，我们不会与任何第三方分享您的个人信息：</span
        >
      </p>
      <p>
        <span style="font-weight: bold">a)&nbsp;事先获得您明确的同意或授权</span
        >；
      </p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
      </p>
      <p>
        <br />
      </p>
      <p>
        c)&nbsp;在法律法规允许的范围内，为维护卓闻、卓闻的关联方或合作伙伴、您或其他卓闻用户或社会公众利益、财产或安全免遭损害而有必要提供；
      </p>
      <p>
        <br />
      </p>
      <p>
        d)&nbsp;只有共享您的信息，才能实现我们和/或关联公司、与我们合作的第三方提供的产品和/或服务的核心功能或提供您需要的服务；
      </p>
      <p>
        <br />
      </p>
      <p>e)&nbsp;应您需求为您处理您与他人的纠纷或争议；</p>
      <p>
        <br />
      </p>
      <p>
        f)&nbsp;符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
      </p>
      <p>
        <br />
      </p>
      <p>g)&nbsp;基于学术研究而使用；</p>
      <p>
        <br />
      </p>
      <p>
        h)&nbsp;国家及行业主管部门法律法规规定的需要向特定第三方（如第三方审计机构、企业上市监管部门）披露的信息；
      </p>
      <p>
        <br />
      </p>
      <p>
        i)&nbsp;卓闻及关联方内部的必要共享。我们只会共享必要的个人信息，且受本《隐私政策》中所作声明目的的约束。如要改变个人信息的处理目的，将再次征求您的授权同意。
      </p>
      <p>
        <br />
      </p>
      <p>j)&nbsp;基于符合法律法规的社会公众利益而使用。</p>
      <p>
        <br />
      </p>
      <p>
        6.1.2&nbsp;<span style="font-weight: bold"
          >为提供更好的客户服务和用户体验，维护和改善我们的产品/服务，我们可能会与第三方共享您的个人信息</span
        >。我们仅会出于合法、正当、必要的目的提供您的个人信息，并且只会提供相关产品和/或服务所必要的个人信息。我们将努力要求该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施，并明确要求该等第三方仅将共享的个人信息用于与卓闻产品和/或服务相关的特定用途。如要改变个人信息的处理目的，该等第三方将再次征求您的授权同意。该第三方包括以下类型：
      </p>
      <p>
        <br />
      </p>
      <p>
        a)&nbsp;供应商/服务提供商。仅为实现本隐私政策中声明的目的，我们的某些服务将由业务合作伙伴提供，以保障为您提供的服务顺利完成，我们可能会将您的个人信息共享给上述合作伙伴，包括技术服务、支付服务、内容服务，其中可能包括您的联络信息、订单信息、支付信息、地址信息等，以保证为您提供的服务顺利完成。
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-family: undefined, undefined, undefined, undefined"
          >例如1)&nbsp;&nbsp;当您把卓闻的项目问卷分享到第三方平台（微信）时，其SDK可能会收集您的设备及网络信息；2）当您上传图片、导入文件、文件存储时，可能会收集您提供的设备、网络及资料信息；3)当您使用微信支付时，其SDK会获取您的设备信息及日志信息(例如设备品牌及型号、操作系统版本号、国际移动设备识别码(IMEI))；4)友盟统计提供用户行为统计，其SDK可能会获取您的设备及网络信息(例如网络设备硬件地址(MAC)、IP&nbsp;地址、GPS位置、网络使用习惯)。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        上述供应商、服务提供商和其他合作伙伴收集和处理信息等行为遵守其自身的隐私政策，而不适用于本隐私政策。同时，为了最大程度保障您的信息安全，我们建议您在使用任何第三方SDK类服务前先行查看其隐私政策。为保障您的合法权益，如您发现该等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。
      </p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;委托我们进行推广的合作伙伴。我们还可能与委托我们进行推广的合作伙伴共享信息，但我们仅会向这些合作伙伴提供推广的覆盖面、有效性以及统计类等信息，而不会提供可以识别您身份的个人信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        c)&nbsp;合作举办活动的合作伙伴。我们可能与合作伙伴合作举办活动，并与其分享活动过程中产生的、为完成活动所必要的一些信息，以便您能参与活动、我们的合作伙伴能及时与您联系、发放奖品。
      </p>
      <p>
        <br />
      </p>
      <p>
        6.1.3&nbsp;为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护卓闻、您或其他卓闻客户的权利及其财产或安全，比如为防止欺诈、网络攻击、钓鱼网站、网络漏洞、计算机病毒、网络攻击、网络侵入此类违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其他方式披露的个人信息。
      </p>
      <p>
        <br />
      </p>
      <p>6.2&nbsp;<span style="font-weight: bold">转让</span></p>
      <p>
        <br />
      </p>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p>
        <br />
      </p>
      <p>a)&nbsp;事先获得您明确的同意或授权；</p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
      </p>
      <p>
        <br />
      </p>
      <p>
        c)&nbsp;符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
      </p>
      <p>
        <br />
      </p>
      <p>
        d)<span style="font-weight: bold"
          >&nbsp;随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。在转移之前，我们会提前进行告知。如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>6.3&nbsp;公开披露</p>
      <p>
        <br />
      </p>
      <p>
        我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
      </p>
      <p>
        <br />
      </p>
      <p>
        a)&nbsp;根据您的要求，在您明确同意的披露方式下披露您所指定的个人信息；
      </p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;<span style="font-weight: bold"
          >根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息</span
        >。&nbsp;在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
      </p>
      <p>
        <br />
      </p>
      <p>6.4&nbsp;征得同意的例外</p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >请您理解，以下情形中，共享、转让、公开披露您的个人信息的，无需事先获得您的授权或同意：</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>a)&nbsp;与国家安全、国防安全直接相关的；</p>
      <p>
        <br />
      </p>
      <p>b)&nbsp;与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>
        <br />
      </p>
      <p>c)&nbsp;与犯罪侦查、起诉、审判和决定书、裁判执行等直接相关的；</p>
      <p>
        <br />
      </p>
      <p>
        d)&nbsp;出于维护您或其他个人的生命、财产重大合法权益但又难以得到本人同意的；
      </p>
      <p>
        <br />
      </p>
      <p>e)&nbsp;您自行向社会公众公开的个人信息；</p>
      <p>
        <br />
      </p>
      <p>
        f)&nbsp;从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开、新媒体平台等渠道。
      </p>
      <p>
        <br />
      </p>
      <p>7.&nbsp;<span style="font-weight: bold">信息安全</span></p>
      <p>
        <br />
      </p>
      <p>
        7.1&nbsp;我们仅在为本《隐私政策》所述目的和法律法规允许的时限内保留您的个人信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        7.2&nbsp;为了保障您的信息安全，卓闻公司会在现有技术水平下采取合理必要的措施来保护您的信息，包括物理、技术和行政管理安全措施来降低丢失、误用、非授权访问、披露和更改的风险，这些保护措施包括：
      </p>
      <p>
        <br />
      </p>
      <p>
        a)&nbsp;我们建立了个人信息相关内控制度，对可能接触到您的个人信息的工作人员采取最小够用授权原则；对工作人员处理您的信息的行为进行系统监控，不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导。
      </p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;我们已制定个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生个人信息安全事件后，我们将按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话或推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
      </p>
      <p>
        <br />
      </p>
      <p>
        c)&nbsp;我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。
      </p>
      <p>
        <br />
      </p>
      <p>
        d)&nbsp;我们的网络服务采取了传输层数据加密的技术，保护用户数据在传输过程中的安全。
      </p>
      <p>
        <br />
      </p>
      <p>
        e)&nbsp;我们采取加密技术对您个人信息进行加密保存，并通过访问限制技术进行隔离。在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、内容隐藏在内多种数据脱敏技术增强个人信息在使用中的安全性。
      </p>
      <p>
        <br />
      </p>
      <p>
        f)&nbsp;我们采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
      </p>
      <p>
        <br />
      </p>
      <p>
        g)&nbsp;我们仅允许有必要知晓这些信息的相关员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。
      </p>
      <p>
        <br />
      </p>
      <p>
        h)&nbsp;请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证个人信息百分之百的安全。请您理解并明白，由于存在各种各样无法预知情况，您接入卓闻服务所用的系统和通讯网络，有可能因我们可控范围之外的情况而发生问题。
      </p>
      <p>
        <br />
      </p>
      <p>
        i)&nbsp;请您理解，互联网并非绝对安全的环境，我们强烈建议您不要使用非卓闻推荐的方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的联系方式、交流信息或分享内容等相关信息的第三方。
      </p>
      <p>
        <br />
      </p>
      <p>
        j)&nbsp;在使用卓闻提供的积分兑换、提现服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账号或密码发生泄漏，请您立即联络交易方，如有必要，我们在得到您的请求后，会立即协助处理前述事项。
      </p>
      <p>
        <br />
      </p>
      <p>
        7.3&nbsp;您在使用卓闻产品和/或服务时，请妥善保管好您的卓闻账号，我们会通过您的账号来识别您的身份。使用账号和秘密进行的任何操作、发出的指令都视为您本人做出，因您自身原因造成的账户、密码等信息被冒用、盗用或非法使用，由此造成的风险和损失由您自行承担。一旦您发现卓闻账号及其验证码因任何原因已经或将受到泄漏时，请您立即联络我们客服，以便我们采取相应措施，但在我们知悉此种情况和在合理时间内采取行动前，我们对此不负任何责任。
      </p>
      <p>
        <br />
      </p>
      <p>8.<span style="font-weight: bold">您分享的信息</span></p>
      <p>
        <br />
      </p>
      <p>
        8.1&nbsp;我们的产品和/或服务，可让您不仅与自己的社交网络，也与使用该产品和/或服务的其他用户公开分享您的相关信息，例如，您在我们的产品和/或服务中所上传或发布的信息（包括您公开的个人信息）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们产品和/或服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p>
        <span style="font-weight: bold"
          >因此，请您谨慎考虑，是否通过我们的产品和/或服务上传、发布和交流相关信息内容。在一些情况下，您可通过联系我们要求从我们的产品和/或服务中删除或者修改您的相关信息。</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        8.2&nbsp;某些个人信息因其特殊性可能被认为是个人敏感信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，个人敏感信息受到更加严格的保护。
      </p>
      <p>
        <br />
      </p>
      <p>
        8.3&nbsp;请注意，您在使用我们的产品和/或服务时所提供、上传或发布的内容和信息（例如有关您个人的照片等信息），可能会泄露您的个人敏感信息。您需要谨慎地考虑，是否在使用我们的产品和/或服务时披露相关个人敏感信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        8.4&nbsp;您同意我们可以按本《隐私政策》所述的目的和方式来处理您的个人敏感信息。
      </p>
      <p>
        <br />
      </p>
      <p>9.&nbsp;第三方服务</p>
      <p>
        <br />
      </p>
      <p>
        9.1&nbsp;我们可能链接至第三方提供的社交媒体，您也可利用“分享”将卓闻某些产品或服务分享至第三方平台。
      </p>
      <p>
        <br />
      </p>
      <p>
        9.2&nbsp;我们也可能使用您的信息，通过我们的产品和/或服务、电子邮件或其他方式向您发送服务信息，提供或推广我们或第三方的如下产品和/或服务：
      </p>
      <p>
        <br />
      </p>
      <p>
        9.2.1&nbsp;我们的产品和/或服务，我们的关联公司和合作伙伴的产品和/或服务；
      </p>
      <p>
        <br />
      </p>
      <p>9.2.2&nbsp;第三方互联网服务供应商。</p>
      <p>
        <br />
      </p>
      <p>
        10.&nbsp;<span style="font-weight: bold"
          >我们可能向您发送的邮件和信息</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>10.1&nbsp;邮件和信息推送</p>
      <p>
        <br />
      </p>
      <p>
        您在使用我们的产品和/或服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。
      </p>
      <p>
        <br />
      </p>
      <p>10.2&nbsp;与产品和/或服务有关的公告</p>
      <p>
        <br />
      </p>
      <p>
        我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与产品和/或服务有关的公告。您可能无法取消这些与产品和/或服务有关、性质不属于广告。
      </p>
      <p>
        <br />
      </p>
      <p>
        11.&nbsp;<span style="font-weight: bold"
          >未成年人使用我们的产品和/或服务</span
        >
      </p>
      <p>
        <br />
      </p>
      <p>
        11.1&nbsp;如您为未满18周岁（含）的未成年人，建议请您的父母或监护人阅读本政策，并在征得您父母或监护人同意的前提下使用我们的服务或向我们提供您的信息。&nbsp;对于经父母或监护人同意而收集您的信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护您的权益所必要的情况下使用或公开披露此信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        11.2&nbsp;如您的监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。
      </p>
      <p>
        <br />
      </p>
      <p>12.隐私政策的适用范围</p>
      <p>
        <br />
      </p>
      <p>
        12.1&nbsp;除某些特定产品和服务外，卓闻旗下所有的产品和/或服务均适用本《隐私政策》。这些特定产品和服务将适用特定的隐私政策。针对某些特定产品和服务的特定隐私政策，将更具体地说明我们在该等产品和服务中如何使用您的信息。该特定产品和/或服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定产品和/或服务的隐私政策。
      </p>
      <p>
        <br />
      </p>
      <p>
        12.2&nbsp;请您注意，本《隐私政策》仅适用于我们所收集、保存、使用、共享、披露信息。除非本《隐私政策》另有明确所指，本《隐私政策》不适用于以下情况：
      </p>
      <p>
        <br />
      </p>
      <p>
        a)&nbsp;通过我们的产品和/或服务而接入的第三方服务（包括任何第三方网站）收集的信息；
      </p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;通过在我们产品和/或服务中进行服务的其他公司或机构所收集的信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        请您知悉：如果您浏览第三方网站或使用第三方的产品和／或服务时向该第三方提供您的个人信息，您的信息应当适用该第三方的隐私声明或类似政策，我们对任何第三方不当使用或披露由您提供的信息不承担任何法律责任，无论您登录或浏览上述网站、软件，或使用其产品和/或服务是否基于卓闻的链接或引导。
      </p>
      <p>
        <br />
      </p>
      <p>13.&nbsp;<span style="font-weight: bold">本政策的变更</span></p>
      <p>
        <br />
      </p>
      <p>
        我们在《隐私政策》发生以下“重大变更”时，我们将在主页显著位置提示或以其他方式通知您。如果您不同意更新后的版本请停止使用我们的产品和/或服务，如果您继续使用我们的产品和/或服务，表示您同意接受修订后的本《隐私政策》的约束：
      </p>
      <p>
        <br />
      </p>
      <p>a)&nbsp;我们的核心业务模式发生重大变化。</p>
      <p>
        <br />
      </p>
      <p>
        b)&nbsp;我们在所有权结构、组织架构、股权结构等方面发生重大变化。如业务调整、破产、重整、并购、分立等引起的所有者变更等。
      </p>
      <p>
        <br />
      </p>
      <p>c)&nbsp;个人信息共享、转让或公开披露的主要对象发生变化。</p>
      <p>
        <br />
      </p>
      <p>d)&nbsp;您参与个人信息处理方面的权利及其行使方式发生重大改变。</p>
      <p>
        <br />
      </p>
      <p>
        e)&nbsp;我们负责受理有关个人信息的投诉、建议和本《隐私政策》&nbsp;联系方式发生变化。
      </p>
      <p>
        <br />
      </p>
      <p>
        如果您还有其他问题和建议，请联系我们。我们会始终致力于充分保护用户信息，并为您提供更优质的体验和服务。
      </p>
      <p>
        <br />
      </p>
      <p>14.&nbsp;<span style="font-weight: bold">联系、投诉及举报</span></p>
      <p>
        <br />
      </p>
      <p>
        如果您在使用卓闻产品/服务过程中发现您的信息被用于违法行为或受到侵害，欢迎您进行积极举报，我们将按照《中华人民共和国网络安全法》等法律的要求受理，您需提供合法有效的权利证明、侵权事实、身份证明等文件以供我们核实，我们将在15日内回复您处理结果，您还可以向网信部门、工信部门、公安及工商等监管部门进行投诉或举报。举报途径如下：
      </p>
      <p>
        <br />
      </p>
      <p>
        a)&nbsp;客服电话：&nbsp;【<span
          style="font-family: undefined, undefined, undefined, undefined"
          >18515810403</span
        >】
      </p>
      <p>
        <br />
      </p>
      <p>b)&nbsp;客户端举报：“首页”-&nbsp;“发表留言”</p>
      <p>
        <br />
      </p>
      <p>15.&nbsp;<span style="font-weight: bold">适用法律与争议解决</span></p>
      <p>
        <br />
      </p>
      <p>a)&nbsp;运营主体：北京卓闻数据科技股份有限公司</p>
      <p>
        <br />
      </p>
      <p>b)&nbsp;注册地址：北京市石景山区实兴大街30号院7号楼8层88号</p>
      <p>
        <br />
      </p>
      <p>16.&nbsp;<span style="font-weight: bold">适用法律与争议解决</span></p>
      <p>
        <br />
      </p>
      <p>
        本《隐私政策》应根据中华人民共和国法律解释与管辖，有关与您和我们之间发生的任何形式的争议均应友好协商解决。协商不成的，任一方均有权将争议提交卓闻所在地有管辖权的人民法院诉讼解决。
      </p>
    </article>
    <p>
      <br />
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {
    // 设置title
    document.title = "隐私政策";
  },
  computed: {},
  methods: {
    showSDK() {
      this.$router.push({
        path: "/sdkInfo",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.privacy_policy {
  width: 100%;
  height: 100vh;
  background-color: #f7f7f7;
  border-top: 2px solid #f5f5f5;
  padding: 46px 24px;
  box-sizing: border-box;
  font-size: 28px;
  line-height: 46px;
  color: #333333;
  .box{
    margin: 40px 0px;
    padding: 0px 1px 1px 0px;
    width: 1446px;
    overflow: auto hidden;
    counter-reset: cellnumber 0;
    table{
        border: 1px solid rgb(221, 221, 221);
        width: 97%;
        td{
            border: 1px solid rgb(221, 221, 221);
            padding: 9px 8px;
            box-sizing: border-box;
            font-size: 28px;
            color: #000;
            word-break: break-word;
        }
        .tit{
            text-align: center;
            font-size: 28px;
            font-weight: bold;
            background-color: rgb(239, 239, 239);
            color: rgb(51, 51, 51);
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/other/privacyPolicy.vue